(() => {
  const initialize = (root) => {
    root.querySelectorAll('.enp__form').forEach((form) => {
      if (form.dataset.enpReady) return;
      form.dataset.enpReady = 'true';
      const destination = form.querySelector('[data-enp-destination]');
      const artwork = form.querySelector('[data-enp-artwork]');
      const instructions = form.querySelector('[data-enp-instructions]');
      const designError = form.querySelector('[data-enp-design-error]');
      const variantInputs = form.querySelectorAll('[data-enp-variant]');
      const submitButton = form.querySelector('[data-enp-submit]');
      const submitContent = form.querySelector('[data-enp-submit-content]');
      const submitPrice = form.querySelector('[data-enp-submit-price]');
      const soldLabel = form.querySelector('[data-enp-sold]');
      const productImage = form.closest('.enp')?.querySelector('.enp__image img');
      const validateDestination = () => {
        destination.setCustomValidity('');
        if (!destination.value) return;
        try {
          const url = new URL(destination.value);
          if (!['https:', 'http:'].includes(url.protocol) || !url.hostname) throw new Error();
        } catch {
          destination.setCustomValidity(destination.dataset.error);
        }
      };
      destination.addEventListener('input', validateDestination);
      destination.addEventListener('change', validateDestination);
      const validateArtwork = () => {
        if (!artwork) return true;
        artwork.setCustomValidity('');
        const file = artwork.files[0];
        const valid = !file || /\.(png|jpe?g|pdf|svg)$/i.test(file.name);
        if (!valid) artwork.setCustomValidity(artwork.dataset.error);
        return valid;
      };
      const validateDesign = () => {
        if (!artwork || !instructions || !designError) return true;
        const complete = Boolean(artwork.files[0] || instructions.value.trim());
        if (!complete) artwork.setCustomValidity(designError.dataset.error);
        if (complete && !artwork.files[0]) artwork.setCustomValidity('');
        designError.textContent = complete ? '' : designError.dataset.error;
        designError.hidden = complete;
        return complete;
      };
      if (artwork) {
        artwork.addEventListener('change', () => {
          validateArtwork();
          validateDesign();
        });
      }
      if (instructions) instructions.addEventListener('input', validateDesign);
      variantInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          const available = input.dataset.available === 'true';
          if (productImage && input.dataset.image) {
            productImage.removeAttribute('srcset');
            productImage.removeAttribute('sizes');
            productImage.src = input.dataset.image;
          }
          if (submitButton) submitButton.disabled = !available;
          if (submitPrice) submitPrice.textContent = input.dataset.price;
          if (submitContent) submitContent.hidden = !available;
          if (soldLabel) soldLabel.hidden = available;
        });
      });
      form.addEventListener('submit', (event) => {
        validateDestination();
        validateArtwork();
        validateDesign();
        if (!form.reportValidity()) event.preventDefault();
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
